import { useState } from 'react';
import Icon from './Icon.jsx';
import { useAuth } from '../../context/AuthContext.jsx';
import { useToast } from '../../context/ToastContext.jsx';
import { resendVerification } from '../../api/userApi.js';

// 已登入但 Email 未驗證時顯示的提醒橫幅（含重寄按鈕）。
// 放在會擋未驗證的頁面（結帳 / 代打登記）最上方。已驗證或未登入則不顯示。
function VerifyEmailBanner() {
  const { user } = useAuth();
  const { showToast } = useToast();
  const [sending, setSending] = useState(false);

  if (!user || user.emailVerified) return null;

  const resend = async () => {
    if (sending) return;
    setSending(true);
    try {
      await resendVerification();
      showToast('驗證信已重新寄出，請收信並點連結完成驗證', 'success', 4000);
    } catch (err) {
      showToast(`重寄失敗：${err.message}`, 'error', 3000);
    } finally {
      setSending(false);
    }
  };

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
      background: '#FFF8E6', border: '1px solid var(--gold, #F5B815)', borderRadius: 12,
      padding: '12px 16px', margin: '0 0 16px',
    }}>
      <span style={{ color: 'var(--gold-deep, #B8860B)', display: 'inline-flex', flexShrink: 0 }}>
        <Icon name="mail" size={20} />
      </span>
      <p style={{ margin: 0, font: '600 13px "Noto Sans TC", sans-serif', color: 'var(--ink-strong)', lineHeight: 1.6, flex: 1, minWidth: 180 }}>
        <b>你的 Email 還沒驗證。</b>請到信箱點驗證連結，完成後才能下單 / 送出登記。
      </p>
      <button
        type="button"
        onClick={resend}
        disabled={sending}
        style={{
          flexShrink: 0, padding: '8px 16px', borderRadius: 999, border: 'none', cursor: sending ? 'wait' : 'pointer',
          background: 'var(--navy)', color: '#fff', font: '800 12px "Noto Sans TC", sans-serif',
        }}
      >
        {sending ? '寄送中…' : '重寄驗證信'}
      </button>
    </div>
  );
}

export default VerifyEmailBanner;
